import React from 'react';
import { Result, Typography } from 'antd';
import { useTranslate } from '@tolgee/react';

type Props = {
  variant: 'invalid' | 'expired';
};

const AbandonedBusinessErrorScreen: React.FC<Props> = ({ variant }) => {
  const { t } = useTranslate();
  const isExpired = variant === 'expired';

  return (
    <Result
      status={isExpired ? 'warning' : 'error'}
      title={
        <Typography.Title level={3} style={{ color: '#1a3c34' }}>
          {isExpired ? t('This link has expired') : t('This link is invalid')}
        </Typography.Title>
      }
      subTitle={
        isExpired
          ? t(
              'The link you used is no longer active. Please contact support for assistance.',
            )
          : t(
              'The link you used is not valid. Please check your email and try again.',
            )
      }
    />
  );
};

export default AbandonedBusinessErrorScreen;
